export const EXPORT_DATA = 'EXPORT_DATA';
export const EXPORT_WIDGET_DATA = 'EXPORT_WIDGET_DATA';
export const EXPORT_ALERT_EVENTS = 'EXPORT_ALERT_EVENTS';
export const EXPORT_VM_DATA = 'EXPORT_VM_DATA';
